module.exports = __webpack_public_path__ + "static/img/follow-hero.9dec588.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/follow-hero.png
// module id = KJJO
// module chunks = 1